"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newRoutes = void 0;
const routeUrls_1 = require("root/src/shared/descriptions/routes/routeUrls");
exports.newRoutes = {
    [routeUrls_1.routeUrls.giveawayHistory()]: {
        url: routeUrls_1.routeUrls.giveawayHistory(),
        modules: [],
    },
    [routeUrls_1.routeUrls.drops()]: {
        url: routeUrls_1.routeUrls.drops(),
        modules: [],
    },
    [routeUrls_1.routeUrls.audienceTargeting()]: {
        url: routeUrls_1.routeUrls.audienceTargeting(),
        modules: [],
    },
    [routeUrls_1.routeUrls.brandUsers()]: {
        url: routeUrls_1.routeUrls.brandUsers(),
        modules: [],
    },
    '/creators/:id': {
        url: '/creators/:id',
        modules: [],
    },
    '/creators/yt/:id': {
        url: '/creators/yt/:id',
        modules: [],
    },
    '/creators/tiktok/:id': {
        url: '/creators/tiktok/:id',
        modules: [],
    },
};
